import cloneDeep from 'lodash/cloneDeep';
import chartHelper from '../chart-helper';
import widgetHelper from '../../widget-utilities/widget-helper';

/* Config builder for column chart */
var columnChartConfigBuilder = function columnChartConfigBuilder() {

    // Add formattedYFields to config
    var addFormattedYFields = function addFormattedYFields(yAxisFields) {
        var formattedYFields = [];
        if (yAxisFields != null) {
            yAxisFields.forEach(function (yField) {
                formattedYFields.push('' + yField);
            });
        }
        return formattedYFields;
    };

    // Add XaxisTickValues to config
    var addXAxisTickValues = function addXAxisTickValues(xAxisTickValuesUrl, xAxisTickValueField) {
        // TODO: Write logic for XAxisTickValues as it uses DownloadDataAsyncCall
        return [];
    };

    // Returns modified chart data
    var modifyChartData = function modifyChartData(data) {
        var dataProperties = ['seriesData', 'sortData'];
        dataProperties.forEach(function (dataProperty) {
            data[dataProperty] = Object.prototype.hasOwnProperty.call(data, dataProperty) ? JSON.parse(data[dataProperty]) : null;
        });
        return data;
    };

    // Add custom properties to original config
    var modifyColumnChartConfigProperties = function modifyColumnChartConfigProperties(config) {
        var _config$ChartConfig = config.ChartConfig,
            YAxisFields = _config$ChartConfig.YAxisFields,
            XAxisTickValuesUrl = _config$ChartConfig.XAxisTickValuesUrl,
            XAxisTickValueField = _config$ChartConfig.XAxisTickValueField,
            LegendLocation = _config$ChartConfig.LegendLocation,
            AggregationType = _config$ChartConfig.AggregationType,
            CrumbFieldConfig = _config$ChartConfig.CrumbFieldConfig,
            CrumbDisplayFieldName = _config$ChartConfig.CrumbDisplayFieldName,
            YAxisNames = _config$ChartConfig.YAxisNames,
            LegendLineCount = _config$ChartConfig.LegendLineCount,
            XAxisField = _config$ChartConfig.XAxisField,
            CategoryDateFormat = _config$ChartConfig.CategoryDateFormat,
            ClassifierField = _config$ChartConfig.ClassifierField,
            SortMatchPropertyName = _config$ChartConfig.SortMatchPropertyName,
            SortValuePropertyName = _config$ChartConfig.SortValuePropertyName,
            Data = config.Data;

        // Initialize properties with empty strings if properties are null

        config.ChartConfig.XAxisField = widgetHelper.initializeConfigPropertyWithEmptyString(XAxisField);
        config.ChartConfig.CategoryDateFormat = widgetHelper.initializeConfigPropertyWithEmptyString(CategoryDateFormat);
        config.ChartConfig.ClassifierField = widgetHelper.initializeConfigPropertyWithEmptyString(ClassifierField);
        config.ChartConfig.XAxisTickValueField = widgetHelper.initializeConfigPropertyWithEmptyString(XAxisTickValueField);
        config.ChartConfig.SortMatchPropertyName = widgetHelper.initializeConfigPropertyWithEmptyString(SortMatchPropertyName);
        config.ChartConfig.SortValuePropertyName = widgetHelper.initializeConfigPropertyWithEmptyString(SortValuePropertyName);

        config.ChartConfig.LegendLocation = chartHelper.modifyLegendLocation(LegendLocation);
        config.ChartConfig.AggregationType = chartHelper.modifyAggregationType(AggregationType);
        config.ChartConfig.CrumbFieldConfig = chartHelper.modifyCrumbFieldConfig(CrumbFieldConfig);
        config.ChartConfig.CrumbDisplayFieldName = chartHelper.modifyCrumbDisplayFieldName(CrumbDisplayFieldName, CrumbFieldConfig);
        config.ChartConfig.YAxisNames = chartHelper.modifyYAxisNames(YAxisNames);
        config.ChartConfig.LegendLineCount = chartHelper.modifyLegendLineCount(LegendLineCount);
        config.ChartConfig.FormattedYFields = addFormattedYFields(YAxisFields);
        config.ChartConfig.YAxisFields = chartHelper.modifyYAxisFields(YAxisFields);
        config.ChartConfig.XAxisTickValues = addXAxisTickValues(XAxisTickValuesUrl, XAxisTickValueField);
        config.Data = modifyChartData(Data);
        return config;
    };

    // Remove unwanted properties, add custom properties and initialize null/undefined values
    var configBuilder = function configBuilder(config) {

        // Add common widget config properties
        config = widgetHelper.modifyWidgetConfigProperties(cloneDeep(config));

        // Add column chart specific config properties
        config = modifyColumnChartConfigProperties(cloneDeep(config));

        return config;
    };

    return {
        configBuilder: configBuilder
    };
};

export default columnChartConfigBuilder();